import { ageBracketList } from "../shared/grailConstants";
import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface AgeBracketSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export default function AgeBracketSelect(props: AgeBracketSelectProps) {
  const { isErrored, onChange, readOnly, required, value } = props;

  return (
    <StringFormCombobox
      id="age-bracket-select"
      options={ageBracketList}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
    />
  );
}
